import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import {
  getBackgroundColorOptions,
  getBorderColorOptions,
  getBorderRadiusOptions,
  getBorderWidthOptions,
} from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import {
  getHeightOptions,
  getMaxHeightOptions,
  getMaxWidthOptions,
  getMinHeightOptions,
  getMinWidthOptions,
  getWidthOptions,
} from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import {
  getColorOptions,
  getFontSizeOptions,
  getFontStyleOptions,
  getFontWeightOptions,
  getLineHeightOptions,
  getTextAlignOptions,
  getTextDecorationOptions,
  getTextTransformOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "primaryButton",
  props: {
    text: {
      prop: "other",
      type: "string",
      value: "Button Text",
    },
    href: {
      prop: "other",
      type: "string",
      value: "",
    },
    target: {
      prop: "other",
      type: "select",
      value: "_self",
    },
    buttonType: {
      prop: "other",
      type: "select",
      value: "primaryButton",
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        default: {
          backgroundColor: getBackgroundColorOptions({
            defaultValue: defaultStyles.default.backgroundColor,
          }),
          borderColor: getBorderColorOptions({
            defaultValue: defaultStyles.default.borderColor,
          }),
          borderRadius: getBorderRadiusOptions({
            defaultValue: defaultStyles.default.borderRadius,
          }),
          borderWidth: getBorderWidthOptions({
            defaultValue: defaultStyles.default.borderWidth,
          }),
          color: getColorOptions(defaultStyles.default.color),
          fontSize: getFontSizeOptions(defaultStyles.default.fontSize),
          fontStyle: getFontStyleOptions(defaultStyles.default.fontStyle),
          fontWeight: getFontWeightOptions(defaultStyles.default.fontWeight),
          lineHeight: getLineHeightOptions(defaultStyles.default.lineHeight),
          textAlign: getTextAlignOptions(defaultStyles.default.textAlign),
          textDecoration: getTextDecorationOptions(
            defaultStyles.default.textDecoration,
          ),
          textTransform: getTextTransformOptions(
            defaultStyles.default.textTransform,
          ),
        },
        hover: {
          backgroundColor: getBackgroundColorOptions({
            defaultValue: defaultStyles.hover.backgroundColor,
          }),
          borderColor: getBorderColorOptions({
            defaultValue: defaultStyles.hover.borderColor,
          }),
          borderRadius: getBorderRadiusOptions({
            defaultValue: defaultStyles.hover.borderRadius,
          }),
          borderWidth: getBorderWidthOptions({
            defaultValue: defaultStyles.hover.borderWidth,
          }),
          color: getColorOptions(defaultStyles.hover.color),
          fontSize: getFontSizeOptions(defaultStyles.hover.fontSize),
          fontStyle: getFontStyleOptions(defaultStyles.hover.fontStyle),
          fontWeight: getFontWeightOptions(defaultStyles.hover.fontWeight),
          lineHeight: getLineHeightOptions(defaultStyles.hover.lineHeight),
          textAlign: getTextAlignOptions(defaultStyles.hover.textAlign),
          textDecoration: getTextDecorationOptions(
            defaultStyles.hover.textDecoration,
          ),
          textTransform: getTextTransformOptions(
            defaultStyles.hover.textTransform,
          ),
        },
        sizing: {
          width: getWidthOptions({
            defaultValue: defaultStyles.sizing.width,
          }),
          height: getHeightOptions({
            defaultValue: defaultStyles.sizing.height,
          }),
          minWidth: getMinWidthOptions({
            defaultValue: defaultStyles.sizing.minWidth,
          }),
          minHeight: getMinHeightOptions({
            defaultValue: defaultStyles.sizing.minHeight,
          }),
          maxWidth: getMaxWidthOptions({
            defaultValue: defaultStyles.sizing.maxWidth,
          }),
          maxHeight: getMaxHeightOptions({
            defaultValue: defaultStyles.sizing.maxHeight,
          }),
        },
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
